import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import { Worldheritagefortdetails } from "../Worldheritage/worldheritagefortdetails";

const Worldheritagefort = () => {
    const { id } = useParams(); // fort name from URL (ex: salher)
    const selectedLang = useSelector((state) => state.language.selectedLang);

    // TAB STATE
    const [activeTab, setActiveTab] = useState("description");
    const tabs = {
        English: {
            description: "Description",
            maps: "Maps",
            gallery: "Gallery",
            video: "Video",
        },
        मराठी: {
            description: "वर्णन",
            maps: "नकाशा",
            gallery: "दालन",
            video: "चलचित्र",
        },
    };


    const fort = Worldheritagefortdetails[id]?.[selectedLang];

    if (!fort)
        return <h1 className="text-center text-2xl mt-10">Fort Not Found</h1>;

    return (
        <div className="bg-[#F6F6EC] min-h-screen px-4 py-16">

            <div className="text-center mb-16">
                <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
                    {fort.name}
                </h1>
                <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
                    <span style={{ color: "#DD9827" }}>
                        <Link to="/" className="hover:underline">
                            {fort.breadcrumb}
                        </Link>{" "}
                        </span ><span>
                        / {fort.breadcrumb2} {" "}
                        /</span> {fort.name}
                </p>
            </div>
            {/* ---------------- TABS ---------------- */}
            <div className="border-b ml-0 sm:ml-16 overflow-x-auto whitespace-nowrap no-scrollbar no-dark-bg">
                <div className="flex space-x-2 sm:space-x-0">
                    {Object.keys(tabs[selectedLang]).map((tab) => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`tab-buttonnn allow-bg-white px-4 py-2 text-sm sm:text-[16px] font-medium ${activeTab === tab ? "active-tab" : ""}`}
                        >
                            {tabs[selectedLang][tab]}
                        </button>

                    ))}
                </div>
            </div>

            {/* ---------------- TAB CONTENT ---------------- */}
            <div className="mt-6 text-[17px] leading-relaxed ml-0 sm:ml-16 text-left">
                {/* Description */}
                {activeTab === "description" && (
                    <div>
                        {/* Description Text */}
                        <p>{fort.description1}</p>
                        <p className="mt-4">{fort.description2}</p>
                        <p className="mt-4">{fort.description3}</p>

                        <div className="mt-6">
                            <img
                                src={fort.fortimage}
                                alt={`${fort.name} Fort`}
                                className="w-full sm:w-3/4 md:w-1/2 mx-auto sm:ml-0 rounded shadow"
                            />
                        </div>
                    </div>
                )}


                {/* Maps */}
                {activeTab === "maps" && (
                    <div className="mt-4 flex flex-col sm:flex-row gap-6">
                        {/* Left: Google Map */}
                        <div className="sm:w-1/2 w-full">
                            <div className="w-full h-64 sm:h-[400px]">
                                <iframe
                                    src={fort.mapLink}
                                    width="100%"
                                    height="100%"
                                    className="rounded shadow"
                                    loading="lazy"
                                    title={`${fort.name} location map`}
                                ></iframe>
                            </div>

                            {/* Location Title */}
                            <p className="mt-8 text-[15px] sm:text-[16px] font-medium">
                                <strong className="font-marathi">{fort.locationtitle}:</strong> {fort.location}
                            </p>
                            <p className="mt-2 text-[15px] sm:text-[16px] font-medium">
                                <strong className="font-marathi">{fort.distancetitle}:</strong> {fort.distance}
                            </p>
                        </div>

                        {/* Right: Route Information */}
                        <div className="sm:w-1/2 w-full flex flex-col justify-start text-[15px] sm:text-[16px]">
                            <h3 className="text-lg font-semibold mb-2 font-marathi">
                                {selectedLang === "English"
                                    ? `${fort.name} Route Information`
                                    : `${fort.name} मार्ग माहिती`}
                            </h3>

                            <div className="space-y-2">
                                {fort.route.map((item, i) => {
                                    const colonIndex = item.indexOf(":");
                                    if (colonIndex !== -1) {
                                        const label = item.slice(0, colonIndex + 1); // Include colon
                                        const text = item.slice(colonIndex + 1).trim();
                                        return (
                                            <p key={i}>
                                                <strong className="font-marathi">{label} </strong>{text}
                                            </p>
                                        );
                                    }
                                    // If no colon, just show the line
                                    return <p key={i}>{item}</p>;
                                })}
                            </div>
                        </div>
                    </div>
                )}

                {/* gallery */}
                {activeTab === "gallery" && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                        {fort.gallery.map((img, i) => (
                            <img
                                key={i}
                                src={img}
                                alt={`${fort.name} ${i + 1}`}
                                className="rounded shadow w-full h-48 object-cover"
                            />
                        ))}
                    </div>
                )}

                {/* video */}
                {activeTab === "video" && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                        {fort.video.map((img, i) => (
                            <img
                                key={i}
                                src={img}
                                alt={`${fort.name} ${i + 1}`}
                                className="rounded shadow w-full h-48 object-cover"
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Worldheritagefort;
